// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITriggerDto } from './ITriggerDto';
import {
    ITriggerDtoFromJSON,
    ITriggerDtoFromJSONTyped,
    ITriggerDtoToJSON,
    ITriggerDtoToJSONTyped,
} from './ITriggerDto';

/**
 * 
 * @export
 * @interface IHealthPlanDeductibleTriggerConfigDto
 */
export interface IHealthPlanDeductibleTriggerConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDeductibleTriggerConfigDto
     */
    trigger_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanDeductibleTriggerConfigDto
     */
    threshold_amount?: number;
    /**
     * 
     * @type {ITriggerDto}
     * @memberof IHealthPlanDeductibleTriggerConfigDto
     */
    trigger?: ITriggerDto;
}

/**
 * Check if a given object implements the IHealthPlanDeductibleTriggerConfigDto interface.
 */
export function instanceOfIHealthPlanDeductibleTriggerConfigDto(value: object): value is IHealthPlanDeductibleTriggerConfigDto {
    return true;
}

export function IHealthPlanDeductibleTriggerConfigDtoFromJSON(json: any): IHealthPlanDeductibleTriggerConfigDto {
    return IHealthPlanDeductibleTriggerConfigDtoFromJSONTyped(json, false);
}

export function IHealthPlanDeductibleTriggerConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanDeductibleTriggerConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'trigger_id': json['trigger_id'] == null ? undefined : json['trigger_id'],
        'threshold_amount': json['threshold_amount'] == null ? undefined : json['threshold_amount'],
        'trigger': json['trigger'] == null ? undefined : ITriggerDtoFromJSON(json['trigger']),
    };
}

export function IHealthPlanDeductibleTriggerConfigDtoToJSON(json: any): IHealthPlanDeductibleTriggerConfigDto {
    return IHealthPlanDeductibleTriggerConfigDtoToJSONTyped(json, false);
}

export function IHealthPlanDeductibleTriggerConfigDtoToJSONTyped(value?: IHealthPlanDeductibleTriggerConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trigger_id': value['trigger_id'],
        'threshold_amount': value['threshold_amount'],
        'trigger': ITriggerDtoToJSON(value['trigger']),
    };
}

